const debounce = <T extends () => void>(callback: T, delay = 700) => {
  let timeout: NodeJS.Timeout

  return () => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      callback()
    }, delay)
  }
}

export default debounce
